// @ts-check
// NOTE: Please keep component names arranged alphabetically
import {SYNCED_DATA_GROUPS_EVENT} from 'common/widgets/data-group-selector/index';

import {ComponentsDoc} from './types';

export const widgetsDoc: ComponentsDoc = {
  'mp-bookmarks-widget': {
    events: {
      submit: {
        when: `cta button is clicked`,
        detail: `action, name?, value?`,
      },
      change: {
        when: `bookmark dropdown opens or closes`,
        detail: `open`,
      },
    },
  },
  'mp-checkbox-list': {
    events: {
      clickItem: {
        when: `List item is clicked`,
        detail: `item`,
      },
      focusItem: {
        when: `List item is focused`,
      },
      selectAll: {
        when: `Select All is clicked`,
      },
      unselectAll: {
        when: `Unselect All is clicked`,
      },
      selectAllMatching: {
        when: `Select All matching elements, only if show-csv-matches is enabled`,
      },
    },
  },
  'mp-context-menu': {
    events: {
      action: {
        when: `item is clicked or goes into submenu, action property contains the type`,
        detail: `action, value?`,
      },
      close: {
        when: `context menu closes`,
      },
    },
  },
  'mp-control-bar': {
    events: {
      select: {
        when: `user clicks button`,
        detail: `value`,
      },
    },
  },
  'mp-custom-event-modal': {
    events: {
      modalClosed: {
        when: `modal is closed`,
      },
      deletedCustomEvent: {
        when: `User clicked delete on modal`,
        detail: `id`,
      },
      savedCustomEvent: {
        when: `User created/saved a custom event`,
        detail: `customEvent`,
      },
    },
  },
  'mp-data-group-selector': {
    events: {
      selectDataGroup: {
        when: `datagroup is selected from drop menu`,
        detail: `dataGroup`,
      },
      [SYNCED_DATA_GROUPS_EVENT]: {
        when: `groups are first loaded and when the group that is selected changes`,
        detail: `dataGroups, selected`,
      },
    },
  },
  'mp-dashboard-selector': {
    events: {
      menuchange: {
        when: `dropdown opens or closes`,
        detail: `state`,
      },
      create: {
        when: `new dashboard is created`,
        detail: `dashboard`,
      },
      multiselect: {
        when: `user selects multiple dashboards`,
        detail: `added, removed`,
      },
      select: {
        when: `user selects a dashboard`,
        detail: `id`,
      },
      star: {
        when: `user stars a dashboard`,
        detail: `id`,
      },
      unstar: {
        when: `user unstars a dashboard`,
        detail: `id`,
      },
    },
  },
  'mp-date-range-picker': {
    events: {
      changeDateRange: {
        when: `Date range is changed via picker`,
        detail: `dateRange`,
      },
    },
  },
  'mp-chart-legend': {
    events: {
      togglecheckbox: {
        when: `the checkbox is toggled`,
        detail: `dictionary of series names and whether they are hidden`,
      },
    },
  },
  'mp-chart-header': {
    events: {
      update: {
        when: `when values are updated`,
      },
      track: {
        when: `action took place that should be tracked`,
      },
    },
  },
  'mp-query-block': {
    events: {
      select: {
        when: `item is selected from dropdown`,
        detail: `item`,
      },
      remove: {
        when: `x is clicked on a removable block`,
      },
      close: {
        when: `dropdown is closed`,
      },
    },
  },
  'mp-query-entry-section': {
    events: {
      track: {
        when: `action took place that should be tracked`,
      },
      update: {
        when: `the entries (event + filters, cohorts, etc) have changed`,
        detail: `entries`,
      },
    },
  },
  'mp-query-multi-block': {
    events: {
      update: {
        when: `item is selected from dropdown`,
        detail: `items`,
      },
      track: {
        when: `action took place that should be tracked`,
      },
    },
  },
  'mp-tag-selector': {
    events: {
      save: {
        when: `tags are saved`,
        detail: `tags`,
      },
      change: {
        when: `user is inputting text, tag is added or removed`,
        detail: `action, tagName, inputText?`,
      },
    },
  },
  'mp-upsell-popup': {
    events: {
      change: {
        when: `popup opens or closes`,
        detail: `state`,
      },
    },
  },
  'mp-sankey-chart': {
    events: {
      addStep: {
        when: `A new step is added to the end`,
      },
      removeStep: {
        when: `The last step was removed`,
      },
      contextMenuOpen: {
        when: `A user clicks one of the nodes`,
        detail: `ev, contextMenu`,
      },
      contextMenuClosed: {
        when: `A user clicks else where/scrolls to de focus the context menu`,
      },
    },
    props: {
      data: {
        tsType: `SankeyFlow`,
        description: `graph structure representing the different paths in the sankey`,
      },
    },
  },
};
